

import React, { useState } from 'react';
import axios from 'axios';
import Footer from './Footer';

const JoinForm = () => {
  const [fullNames, setFullNames] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [birthdate, setBirthdate] = useState('');
  const [tellUsMore, setTellUsMore] = useState('');
  const [selectedTeam, setSelectedTeam] = useState('');
  const [otherTeam, setOtherTeam] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [progress, setProgress] = useState(0);

  const handleTeamChange = (e) => {
    const value = e.target.value;
    setSelectedTeam(value);
    if (value !== 'other') {
      setOtherTeam('');
    }
  };

  const handleOtherTeamChange = (e) => {
    setOtherTeam(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage('');
    setErrorMessage('');

    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/joinus/upload`, {
        names: fullNames,
        phone,
        email,
        age: birthdate,
        reason: tellUsMore,
        team: selectedTeam === 'other' ? otherTeam : selectedTeam,
      });

      if (response.status === 200) {
        setSuccessMessage('Registration successful! Please wait for review and approval from Elayone Music');
        // Simulate progress
        setProgress(100);

        setFullNames('');
        setPhone('');
        setEmail('');
        setBirthdate('');
        setTellUsMore('');
        setSelectedTeam('');
        setOtherTeam('');

        setTimeout(() => {
          setProgress(0);
          setSuccessMessage('');
        }, 10000);
      }
    } catch (error) {
      setErrorMessage('Failed to upload registration!');
      // Simulate error progress
      setProgress(100);
      setTimeout(() => {
        setProgress(0);
        setErrorMessage('');
      }, 5000);
    }
  };

  return (
    <div>
    <div className="flex items-center justify-center pt-[120px] min-h-screen bg-black">
      <div className="bg-black border border-gray-700 bg-opacity-80 text-white p-8 rounded-lg max-w-md w-full mx-4">
        <h2 className="text-3xl text-center mb-4 font-greatvibes">Join a Team</h2>
        <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
          <input
            type="text"
            placeholder="Fullnames"
            value={fullNames}
            onChange={(e) => setFullNames(e.target.value)}
            required
            className="border border-gray-700 p-2 rounded bg-transparent text-white placeholder-gray-400 focus:outline-none focus:border-gray-500"
          />
          <input
            type="tel"
            placeholder="Phone Number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
            className="border border-gray-700 p-2 rounded bg-transparent text-white placeholder-gray-400 focus:outline-none focus:border-gray-500"
          />
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="border border-gray-700 p-2 rounded bg-transparent text-white placeholder-gray-400 focus:outline-none focus:border-gray-500"
          />
          <label className="flex flex-col">
            <span className="mb-1 text-gray-300">Birth Date</span>
            <input
              type="date"
              value={birthdate}
              onChange={(e) => setBirthdate(e.target.value)}
              required
              className="border border-gray-700 p-2 rounded bg-transparent text-white placeholder-gray-400 focus:outline-none focus:border-gray-500"
            />
          </label>

          <textarea
            placeholder="Tell us more (optional)"
            value={tellUsMore}
            onChange={(e) => setTellUsMore(e.target.value)}
            rows="4"
            className="border border-gray-700 p-2 rounded bg-transparent text-white placeholder-gray-400 focus:outline-none focus:border-gray-500"
          />

          <div className="flex flex-col space-y-2">
            <span className="text-lg text-gray-300">Which team are you interested in? *</span>
            {/* Radio buttons for team selection */}
            {['music', 'prayers', 'evangelism', 'mercy_ministry', 'ict', 'protocol', 'other'].map((team) => (
              <label key={team} className="flex items-center text-gray-400">
                <input
                  type="radio"
                  name="team"
                  value={team}
                  checked={selectedTeam === team}
                  onChange={handleTeamChange}
                  className="mr-2 accent-blue-500"
                />
                {team.toUpperCase().replace('_', ' ')}
              </label>
            ))}
            {selectedTeam === 'other' && (
              <input
                type="text"
                placeholder="Please specify"
                value={otherTeam}
                onChange={handleOtherTeamChange}
                className="border border-gray-700 p-2 rounded bg-transparent text-white placeholder-gray-400 focus:outline-none focus:border-gray-500"
              />
            )}
          </div>

          <div className="flex justify-end">
            <button
              type="submit"
              className="bg-gray-700 text-gray-300 text-sm py-1 px-4 rounded hover:bg-gray-600"
            >
              Submit
            </button>
          </div>
        </form>

        {/* Success Message Popup */}
        {successMessage && (
          <div className="fixed top-6 left-0 right-0 mx-auto w-64 bg-green-100 text-green-900 border-green-500 pt-2 rounded-t-md shadow-md z-50">
            <div className="flex justify-center items-center">
              <span className="text-center p-1">{successMessage}</span>
            </div>
            <div className="h-1 mt-1 bg-green-300">
              <div style={{ width: `${progress}%` }} className="h-full bg-green-700 transition-all duration-500" />
            </div>
          </div>
        )}

        {/* Error Message Popup */}
        {errorMessage && (
          <div className="fixed top-6 left-0 right-0 mx-auto w-64 bg-red-100 text-red-900 border-red-500 pt-2 rounded-t-md shadow-md z-50">
            <div className="flex justify-center items-center">
              <span className="text-center p-1">{errorMessage}</span>
            </div>
            <div className="h-1 mt-1 bg-red-300">
              <div style={{ width: `${progress}%` }} className="h-full bg-red-700 transition-all duration-500" />
            </div>
          </div>
        )}
      </div>
    </div>

<Footer />
</div>
  );
};

export default JoinForm;
